import { all, fork, put, takeEvery } from "redux-saga/effects";
import { protoHandler } from "../../libs/proto";
import { CLIENT_RESOLVE_USERNAME, USER_INFO } from "../../constants/methods";
import { addUser } from "./actions";
import { GET_USER, GetUserActionType, GOTO_USER, GoToUserActionType } from "./types";
import { ClientResolveUsernameResponse } from "../../proto/ClientResolveUsername_pb";
import { Room } from "../../proto/Global_pb";
import { goToRoomByRoomName, goToUserByUsername } from "../../libs/services";

function* onGetUser() {
  yield takeEvery<GetUserActionType>(GET_USER, function* (action) {
    try {
      const user = yield protoHandler(USER_INFO, { userId: action.payload.userId });
      yield put(addUser(user.user));
    } catch (e) {}
  });
}

function* onGoToUser() {
  yield takeEvery<GoToUserActionType>(GOTO_USER, function* (action) {
    try {
      let username = action.payload.userId;
      if (username.includes("@")) username = username.replace("@", "");
      const { user, room, type }: ClientResolveUsernameResponse.AsObject = yield protoHandler(CLIENT_RESOLVE_USERNAME, { username: username }).then();
      type === Room.Type.CHAT ? goToUserByUsername(user) : goToRoomByRoomName(room);
    } catch (e) {}
  });
}

export function* usersSaga() {
  yield all([fork(onGetUser), fork(onGoToUser)]);
}
